import React from 'react';
import { IssueReportState } from '../../components/common/IssueReportState';
import type { ThemeColors } from '../../shared/theme';
import { getErrorMessage } from '../../platform/support/issueReport';

type PreferencesCatalogUnavailableProps = {
  colors: ThemeColors;
  page_title: string;
  tab_label: string;
  issue: string;
  api_endpoint: string;
  customer_id?: number;
  http_status?: number;
  error?: unknown;
};

/** Catalog load failure with WhatsApp support and automatic local issue log. */
export function PreferencesCatalogUnavailable({
  page_title,
  tab_label,
  issue,
  api_endpoint,
  customer_id,
  http_status,
  error,
}: PreferencesCatalogUnavailableProps) {
  const error_message = getErrorMessage(error);

  return (
    <IssueReportState
      compact
      error={error}
      issue_context={{
        page: page_title,
        issue,
        kind: 'api',
        api_endpoint,
        http_method: 'GET',
        http_status,
        error_message,
        detail_lines: [`Section: ${tab_label}`],
      }}
      customer_id={customer_id}
    />
  );
}
